module.exports = __webpack_public_path__ + "static/img/t25.ff6df1b8.png";